module.exports = __webpack_public_path__ + "img/contact_attendant.98840129.png";